module.exports = __webpack_public_path__ + "static/media/mobile_stories.06e4b8a9.png";